// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_VFX","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_7CW FallbackBulkDownloadUpsellModalControl-cls1_VFX"};